const { registerBlockType } = wp.blocks;
const { __ } = wp.i18n;
import logo from '../logo';
import GiveawayEdit from './edit';

registerBlockType( 'simple-giveaways/countdown', {
    title:  __( 'Countdown' ),
    description: __( 'Show the giveaway countdown' ),
    icon: logo,
    category: 'simple-giveaways',
    attributes: {
        id: {
            type: 'string',
            default: '0'
        },
    },
    edit: GiveawayEdit,
    save() {
        return null;
    }
});